// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"92c44c0e","339":"f213e3f3","400":"266b141a","514":"60a3da29","548":"38487dc4","806":"c15318d6"}[chunkId] + ".chunk.js";
};